export default __webpack_public_path__ + "static/media/London.e51ee883.jpeg";